import { render, staticRenderFns } from "./scxxDeatil.vue?vue&type=template&id=27814c3b&scoped=true&"
import script from "./scxxDeatil.vue?vue&type=script&lang=js&"
export * from "./scxxDeatil.vue?vue&type=script&lang=js&"
import style0 from "./scxxDeatil.vue?vue&type=style&index=0&id=27814c3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27814c3b",
  null
  
)

export default component.exports